import Successmsg from '../../components/successmsg';
function Success(params) {
  return (
    <>
    <Successmsg/>
</>
  )
}

export default Success;